import React from 'react';
import { ConfigResponse, TippingPercentagesValue } from '../../store/modules/merchant/types';
import PageWrapper from '../../common/PageWrapper';
import { useMerchant } from '../../contexts/MerchantContext';
import { TippingForm } from './components/TippingForm';
import { toast } from '../../util/toast';
import { useGetConfigsQuery, useGetCredentialsQuery } from '../../store/modules/merchant/api';
import { useConfigUpsert } from '../../hooks';

export const Tipping = () => {
  const { merchantId, isLoading: merchantInfoLoading, canUpdateMerchantSettings } = useMerchant();
  const hasModifyAccess = canUpdateMerchantSettings();
  const { data: configs, isLoading: isLoadingConfigs } = useGetConfigsQuery(merchantId, {
    skip: !merchantId,
  });
  const tippingPercentagesConfig = configs?.find((c) => c.name === 'TIPPING_PERCENTAGES') as
    ConfigResponse<TippingPercentagesValue> | undefined;

  const { onConfigUpsert, isLoading: isSaving } = useConfigUpsert(merchantId);
  const { data: credentialData, isLoading: isLoadingCredentials } = useGetCredentialsQuery(
    { merchantId, type: ['ecommerce'] },
    { skip: !merchantId },
  );
  const ecommerceCredentials = credentialData?.ecommerce?.credentials ?? [];
  const isCustomMerchant = ecommerceCredentials.some(
    (credential) => credential?.systemOfOrigin === 'custom',
  );

  return (
    <PageWrapper
      showParentHierarchyBanner
      title="Tipping"
      description="When tipping is enabled, Skipify will display the option to tip to your customers during checkout."
      isLoading={merchantInfoLoading || isLoadingConfigs || isLoadingCredentials}
      data-testid="TIPPING"
    >
      <TippingForm
        key={tippingPercentagesConfig?.configId ?? merchantId}
        tippingPercentagesConfig={tippingPercentagesConfig}
        isTippingSupported={isCustomMerchant}
        onSave={async ({ value, enabled }) => {
          try {
            await onConfigUpsert({
              enabled,
              name: 'TIPPING_PERCENTAGES',
              value,
              configId: tippingPercentagesConfig?.configId,
              merchantId: tippingPercentagesConfig?.merchantId,
            });
            toast.success('Changes saved successfully');
          } catch {
            toast.error(
              'An error occurred while saving these changes. Please try again later or contact Skipify Support',
            );
          }
        }}
        isSaving={isSaving}
        readOnly={!hasModifyAccess}
      />
    </PageWrapper>
  );
};
